module.exports = __webpack_public_path__ + "img/download-on-the-app-store-pt.8fd45f10.svg";